import { ObjectPaths } from '@/types/utils';

import { z } from 'zod';

const PermissionSchema = z.object({
  global: z.boolean(),
  site: z.boolean(),
});

const CrudPermissionSchema = z.object({
  canRead: PermissionSchema,
  canEdit: PermissionSchema,
  canDelete: PermissionSchema,
});

export const RolePermissionsSchema = z.object({
  pii_access: PermissionSchema,
  eligibility_checklist: z.object({
    canRead: PermissionSchema,
    canPerformPrimaryCheck: PermissionSchema,
    canPerformSecondaryCheck: PermissionSchema,
    canPerformCoInvestigatorCheck: PermissionSchema,
    canApproveOverallEligibility: PermissionSchema,
  }),
  assessments: CrudPermissionSchema,
  consent_form: CrudPermissionSchema.extend({
    canCreateTemplate: PermissionSchema,
  }),
  subject: CrudPermissionSchema,
  study_profile: CrudPermissionSchema,
  patient: CrudPermissionSchema,
  site: CrudPermissionSchema,
  user: CrudPermissionSchema,
  procedure_cockpit: z.object({
    canLaunchProcedureCockpit: PermissionSchema,
  }),
  cueing_app: z.object({
    canLaunchCueingApp: PermissionSchema,
  }),
  procedure: z.object({
    canRead: PermissionSchema,
    canEdit: PermissionSchema,
    canDeleteFiles: PermissionSchema,
    canSchedule: PermissionSchema,
    canApprovePlanning: PermissionSchema,
  }),
});

export type RolePermissions = z.infer<typeof RolePermissionsSchema>;
export type Permission = z.infer<typeof PermissionSchema>;
export type PermissionPath = ObjectPaths<RolePermissions, Permission>;
